export default __webpack_public_path__ + "static/media/centro_andes_2_6.4e0198d7.JPG";